/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ScanInputs */



/**
* | output |
* | --- |
* | "Scan tracks" |
*
* @param {Audio_Embed_Export_ScanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan = /** @type {((inputs?: Audio_Embed_Export_ScanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ScanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pistes de numérisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scanspuren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tracce di scansione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сканирование треков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pistas de escaneo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扫描轨迹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スキャントラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक स्कैन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Rastreamento de trilhas")
	return /** @type {LocalizedString} */ ("Scan tracks")
});